export interface Donation {
  donatedOrgId: number;
  donationAmount: number;
  donatorEmail: string;
  tippingSr: boolean;
}
